import React from 'react';

const EsporaiButton = ({ children, className, variant = 'primary', disabled, ...props }) => {
  const baseClasses = 'px-4 py-2 rounded-xl font-medium focus:outline-none';
  const variantClasses = {
    primary: 'bg-primary text-white hover:bg-dark hover:bg-opacity-80 ',
    primaryLight: 'bg-primary-light text-white hover:bg-primary-light hover:bg-opacity-80',
    secondary: 'bg-white text-gray-light hover:bg-gray',
    outline: 'border border-gray-light text-gray hover:bg-gray hover:text-white',
  };
  
  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : '';

  return (
    <button 
      className={`${baseClasses} ${variantClasses[variant]} ${disabledClasses} ${className}`} 
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default EsporaiButton;